/* eslint-disable react/jsx-no-bind */
import React, { useState } from 'react';
import { Flex, Box, Badge, Button, Image, IconButton, Tooltip } from 'pcln-design-system';
import { InformationOutline } from 'pcln-icons';
import styled from 'styled-components';
const PennyToolTip = props => {
  const [isDisplayed, setTooltipDisplayState] = useState(false);
  const {
    onClearHistory,
    isMobile,
    tooltipZIndex,
    isStandalone
  } = props;
  const TRAVEL_BOT_LOGO = 'https://s1.pclncdn.com/design-assets/pcln-bot/logos/pcln_bot_penny_logo_v1.1.svg';
  const StyledTooltip = /*#__PURE__*/styled(Tooltip).withConfig({
    displayName: "PennyToolTip__StyledTooltip",
    componentId: "sc-1embl9s-0"
  })(["left:", ";width:", ";text-align:left;"], props => props.isMobile ? '16px' : '-8px', props => props.isStandalone && props.isMobile ? '145px' : '300px');
  const StyledFlex = /*#__PURE__*/styled(Flex).withConfig({
    displayName: "PennyToolTip__StyledFlex",
    componentId: "sc-1embl9s-1"
  })(["align-items:center;z-index:", ";"], props => props.tooltipZIndex || '10');
  const IconButtonProps = {
    ml: 2,
    id: 'openTooltipButton',
    'data-testid': 'openTooltipButton',
    title: 'open tooltip',
    onClick: e => {
      e.preventDefault();
      setTooltipDisplayState(!isDisplayed);
    },
    icon: React.createElement(InformationOutline, {
      size: 16
    })
  };
  return React.createElement(StyledFlex, {
    tooltipZIndex: tooltipZIndex
  }, React.createElement(Image, {
    src: TRAVEL_BOT_LOGO,
    height: '28',
    width: '68',
    alt: 'Travel Bot Logo'
  }), React.createElement(Badge, {
    color: 'primary',
    bg: 'background.light'
  }, "BETA"), onClearHistory && React.createElement(Button, {
    ml: '2',
    size: 'small',
    variation: 'plain',
    onClick: onClearHistory
  }, "Clear"), React.createElement(Box, {
    mr: '0'
  }, React.createElement(IconButton, Object.assign({}, IconButtonProps, {
    onClick: () => setTooltipDisplayState(!isDisplayed)
  })), isDisplayed && React.createElement(StyledTooltip, {
    isStandalone: isStandalone,
    bg: 'background.darkest',
    color: 'background.lightest',
    center: isMobile,
    left: !isMobile,
    isMobile: isMobile
  }, "Powered by OpenAI. Chat transcripts are recorded for quality review purposes. Penny can make mistakes. Please do not share any personal information in the chat.", React.createElement("br", null), React.createElement("br", null), "\u00A9 2024 Priceline - Patent Pending")));
};
export default PennyToolTip;